import Zones from "../../../../pages/Masters/Zones";
import ZonesNewEdit from "../../../../pages/Masters/Zones/NewEdit"
import Detail from "../../../../pages/Masters/Zones/Detail"

const routerZones = [
    {
        key: "zones",
        path: "/masters/zones",
        element: <Zones />,
    },
    {
        key: "zones",
        path: "/masters/zones/:id",
        element: <Detail />,
    }, 
    { 
        key: "zones",
        path: "/masters/zones/new",
        element: <ZonesNewEdit />,
    },
]

export default routerZones
